import React from 'react';
import { Button } from './ui/Button';
import { Flame, ArrowDown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function PromoBanner() {
  const scrollToPricing = () => {
    const element = document.getElementById('pricing-section');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="bg-gradient-to-r from-red-600 via-red-500 to-orange-500 relative overflow-hidden" data-id="element-335">
      {/* Animated background pulse */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.1),transparent_70%)] animate-pulse" data-id="element-336" />

      <div className="relative z-10 max-w-4xl mx-auto px-5 py-6 md:py-8 text-center" data-id="element-337">
        <FadeIn instant data-id="element-338">
          <div className="flex items-center justify-center gap-2 mb-3" data-id="element-339">
            <Flame className="w-6 h-6 md:w-7 md:h-7 text-yellow-300 animate-bounce" data-id="element-340" />
            <span className="text-white font-black text-lg md:text-2xl uppercase tracking-wide" data-id="element-341">
              Super Promo
            </span>
            <Flame className="w-6 h-6 md:w-7 md:h-7 text-yellow-300 animate-bounce" data-id="element-342" />
          </div>

          <p className="text-white text-base md:text-xl font-bold leading-relaxed mb-2 max-w-2xl mx-auto" data-id="element-343">
            🤯 ¡Nos volvimos locos! Como agradecimiento por tus compras hemos
            bajado los precios de{' '}
            <span className="text-yellow-300 underline underline-offset-4" data-id="element-344">
              todos nuestros productos
            </span>{' '}
            a tan solo:
          </p>

          <div className="my-4 md:my-5" data-id="element-345">
            <span className="text-white/60 line-through text-2xl md:text-3xl font-bold mr-3" data-id="element-346">
              $29.99 USD
            </span>
            <span className="text-yellow-300 text-5xl md:text-7xl font-black drop-shadow-lg" data-id="element-347">
              $7.99 USD
            </span>
          </div>

          <p className="text-white/90 text-sm md:text-lg font-medium mb-5" data-id="element-348">
            ⏰ Solo por esta semana — ¡Aprovecha, se acaba pronto!
          </p>

          <Button onClick={scrollToPricing} className="bg-[#0a1628] text-white hover:bg-[#0a1628]/80 text-base md:text-lg px-8 md:px-12 py-4 md:py-5 shadow-2xl font-bold" data-id="element-349">
            <span data-id="element-350">¡Quiero aprovechar ahora!</span>
            <ArrowDown className="w-5 h-5 ml-2 animate-bounce" data-id="element-351" />
          </Button>
        </FadeIn>
      </div>
    </div>;
}